import { useMediaQuery } from "@/hooks/use-media-query";

type NavigatorWithStandalone = Navigator & { standalone?: boolean };

/**
 * Detects when the app is running as an installed web app.
 *
 * iOS home-screen web apps expose `navigator.standalone`, while other
 * browsers generally rely on the display-mode media query.
 */
export function useIsStandaloneDisplayMode(): boolean {
    const matchesStandaloneDisplayMode = useMediaQuery("(display-mode: standalone)");

    if (typeof window === "undefined") {
        return matchesStandaloneDisplayMode;
    }

    return matchesStandaloneDisplayMode || Boolean((window.navigator as NavigatorWithStandalone).standalone);
}
